import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {Store} from '@ngrx/store';

import {AuthService} from '../service';
import {ACTION} from "../../shared/constant";

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private store: Store<any>, private authService: AuthService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
    this.store.select<any>('PERSON_REDUCER')
      .map(s => s.user)
      .isEmpty()
      .take(1)
      .subscribe(() => {
        if (state.url.lastIndexOf('/error') !== 0) {	// Try loading for first time, if error, handle it and dont keep trying forever
          this.store.dispatch({type: ACTION.LOAD_CURRENT_USER});
        }
      });

    return Promise.resolve(true);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/guard/auth.guard.ts